import {default as _} from 'lodash';
import { Component, OnInit, ViewChild, } from '@angular/core';
import { MessageService,ConfirmationService } from 'primeng/api';
import { DecimalPipe, LowerCasePipe,CommonModule, DatePipe} from '@angular/common';
import { map, Subscription } from 'rxjs';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UrlsService } from '../../../Services/urls.service';
import { UserService } from '../../../Services/user.service';
import { SharedHttpClientService } from '../../../Services/shared-http-client.service';
import { APIURL } from '../../../Constant/API_Urls';
import { DataService } from 'app/Shared/Services/data.service';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { GridService } from 'app/Shared/Services/grid.service';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import saveAs from 'file-saver';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TableModule } from 'primeng/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MatButtonModule } from '@angular/material/button';
import { DatepickerCalendarComponent } from '../../datepicker-calendar/datepicker-calendar.component';
import { DatepickerService } from '../../datepicker-calendar/datepicker.service';
import { Select } from 'primeng/select';
import { ProgressBar } from 'primeng/progressbar';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    imports: [FileUploadModule, ConfirmDialogModule, Select,ProgressBar,
        MatProgressSpinnerModule, TableModule,CommonModule, LowerCasePipe, MatTooltipModule, TooltipModule, DialogModule,
        MatDividerModule, FormsModule, DecimalPipe, ButtonModule, ToastModule, MatButtonModule, DatepickerCalendarComponent
    ],
    providers: [],
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @ViewChild('fileUpload') myfiles!: FileUpload;
  selectedColumns!: any[];
  FileUploadUrl: any;
  tempFileUploadUrl: any;
  action: any = "upload";
  ValidateFileName: any;
  MPID: any;
  public currentdate = new Date();
  public FileExtentionValue: any = "";
  getFileTypeMessage: any = 'Select .csv and .psv files only'
  public FileTypeValue: any;
  public ClientDataFileTypeValue: any = [];
  public CATDataFileTypeValue: any;
  /* boolean variables */
  public isLoadingResults = false;
  startProcessing!: boolean;
  clearData!: boolean;
  isValideFiles!: boolean;
  isUploadEnable!: boolean;
  isStartProcessingDisable: boolean = true;
  isDiableFileType: boolean = true;
  isDiableFileupload: boolean = true;
  public dataset: any = [];
  /* file opearation variables */
  public uploadedFiles: any[] = [];

  public files = [];
  fileBuffer: string = "";
  httpHeaders!: HttpHeaders;
  /* dropdown variables */
  isScriptProcessing!: boolean;
  reportDateValue: Array<any> = [];
  groupValue: string = '';
  submitterValue: string = '';
  totalSizePercent : number = 0;
  public FileType = [
    { label: 'CAT', value: 'CAT' },
    { label: 'Client Data', value: 'Client Data' },
    { label: 'CAIS', value: 'CAIS' },
    { label: 'Submit CAT File', value: 'Submit CAT File' },
    { label: 'FINRA Named Error File', value: 'FINRA Named Error File' }
  ];
  public groupList :any= [];
  public submitterList:any = [];
  public ClientDataFileType = [
    { label: 'Order', value: 'Order' },
    { label: 'Trade', value: 'Trade' },
    { label: 'Route', value: 'Route' },
    { label: 'Recon', value: 'Recon' },
    { label: 'Trade Report', value: 'Trade Report' }];

  public CATDataType = [
    { label: 'CAT Metadata', value: 'CAT Metadata' },
    { label: 'CAT Data Files', value: 'CAT' }];
  public GridColumns:any = [];
  public gridColumnsCAT = [
    { header: "Action", field: "action", datatype: "String", display: "true" },
    { header: "Report Date", field: "reportDate", datatype: "String", display: "true" },
    { header: "Submitter", field: "submitter", datatype: "String", display: "true" },
    { header: "File Name", field: "fileName", datatype: "String", display: "true" },
    { header: "Group", field: "groupName", datatype: "String", display: "true" },
    { header: "Record Count", field: "recordCount", datatype: "int", display: "true" },
    { header: "Status", field: "processStatus", datatype: "String", display: "true" },
    { header: "Update Date Time", field: "fileModified", datatype: "String", display: "true" },
    { header: "File Detail", field: "FileKind", datatype: "String", display: "true" },
    { header: "File Source", field: "Source", datatype: "String", display: "true" },
    { header: "User", field: "User_ID", datatype: "String", display: "true" },
    { header: "File Type", field: "type", datatype: "String", display: "true" },
    { header: "Id", field: "id", datatype: "int", display: "true" },
    { header: "Parent File", field: "parentFileID", datatype: "int", display: "true" }
  ];

  public gridColumnsClient = [
    { header: "FileName", field: "fileName", datatype: "String", display: "true" },
    { header: "Record Count", field: "recordCount", datatype: "String", display: "true" },
    { header: "Processed Flag", field: "processedFlag", datatype: "String", display: "true" },
    { header: "Report Date", field: "reportDate", datatype: "String", display: "true" },
    { header: "Updated Date", field: "updatedDate", datatype: "String", display: "true" },
    { header: "Updated By", field: "updatedBy", datatype: "String", display: "true" },
    { header: "RejRecord Count", field: "rejRecordCount", datatype: "String", display: "true" },
    { header: "Skipped Record Count", field: "skippedRecordCount", datatype: "String", display: "true" },
    { header: "Client File Id", field: "clientFileId", datatype: "String", display: "true" },
    { header: "BatchId", field: "batchId", datatype: "String", display: "true" },
    { header: "Created Date", field: "createdDate", datatype: "String", display: "true" },
    { header: "CreatedBy", field: "createdBy", datatype: "String", display: "true" }
  ];

  public gridColumnsCAIS = [
    { header: "Action", field: "action", datatype: "String", display: "true" },
    { header: "Report Date", field: "reportDate", datatype: "String", display: "true" },
    { header: "FileName", field: "fileName", datatype: "String", display: "true" },
    { header: "Processed Flag", field: "processedFlag", datatype: "String", display: "true" },
    { header: "Processed Status", field: "processStatus", datatype: "String", display: "true" },
   
    { header: "Record Count", field: "recordCount", datatype: "String", display: "true" },
    { header: "Rejected Count", field: "rejRecordCount", datatype: "String", display: "true" },
    { header: "Received FDID Records", field: "receivedFDIDRecordCount", datatype: "String", display: "true" },
    { header: "Accepted FDID Records", field: "successfulFDIDRecordCount", datatype: "String", display: "true" },
    { header: "Received TIDs Count", field: "receivedTIDsCount", datatype: "String", display: "true" },
    { header: "Accepted TIDs Count", field: "successfulTIDsCount", datatype: "String", display: "true" },
    { header: "Received Natural Record", field: "receivedNaturalRecordCount", datatype: "String", display: "true" },
    { header: "Accepted Natural Record", field: "successfulNaturalRecordCount", datatype: "String", display: "true" },
    { header: "Received LegalEntity Record", field: "receivedLegalEntityRecordCount", datatype: "String", display: "true" },
    { header: "Accepted LegalEntity Record", field: "successfulLegalEntityRecordCount", datatype: "String", display: "true" },
    { header: "CorrectionAction Count", field: "receivedCorrectionActionCount", datatype: "String", display: "true" },

    { header: "File Source", field: "source", datatype: "String", display: "true" },
    { header: "File Type", field: "fileType", datatype: "String", display: "true" },
    { header: "Created Date", field: "createdDate", datatype: "String", display: "true" },
    { header: "Created By", field: "updatedUser", datatype: "String", display: "true" },
    { header: "Updated Date", field: "updatedDate", datatype: "String", display: "true" },
    { header: "Updated By", field: "updatedUser", datatype: "String", display: "true" },
  ];
  
  downloadStatus = "";
  selectedRow: any = [];
  selectedRowLength: number = 0;
  array: any = [];
  filterByGui: boolean = false;
  selectedReportDate: Date = new Date();
  isSelectProcessDate: boolean = false;
  isLoadingGroupList!: boolean;
  groupListDropDown: any = [];
  selectedGroup: any = null;
  isDisableSubmit: boolean = true;
  subscription!: Subscription;
  groupName:any;
  constructor(private emitterService: EmitterService,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private dataService: DataService,
    private gridService: GridService,
    private urlsService: UrlsService,
    public userService: UserService,
    public constantService:ConstantService,
    private confirmationService: ConfirmationService,
    public datepickerService : DatepickerService,
    private sharedHttpClientService: SharedHttpClientService) {
      // Initialize HTTP Header Token for Accessing API
      this.httpHeaders = this.sharedHttpClientService.fileUploadToken();

      this.FileTypeValue = "";
      this.action = "upload";
      this.GridColumns = this.gridColumnsCAT;
      this.CATDataFileTypeValue = "CAT Metadata";
      this.tempFileUploadUrl = this.urlsService.setAPIURl(
        APIURL.FileUploadURL);
  }

  transformDateFormatt(date:any) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.MPID = this.userService.getActiveMPID();
    // get yesterday date
    this.reportDateValue[0] = this.userService.CATLastExecutionDate;
    this.reportDateValue[1] = this.userService.CATLastExecutionDate;
    this.validateFileType(this.FileTypeValue);
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getFileUploadDetails();
      }
    });
  }

  applyDate(FileTypeValue:any)
  {
    FileTypeValue = FileTypeValue !== null ? FileTypeValue.toLocaleUpperCase() : "";
    if(this.datepickerService.dateRange != undefined){
      this.reportDateValue[0] = this.datepickerService.dateRange[0];
      this.reportDateValue[1] = this.datepickerService.dateRange[1];
    }else{
      this.reportDateValue[0] = new Date();
      this.reportDateValue[1] = new Date();
    }
    if (FileTypeValue == ("Client Data").toLocaleUpperCase()) {
      this.reportDateValue[0] = this.userService.LastClientReportDate;
      this.reportDateValue[1] = this.userService.LastClientReportDate;
      this.datepickerService.dateRange=[];
      this.datepickerService.dateRange[0] =new Date(this.reportDateValue[0]);
      this.datepickerService.dateRange[1] =new Date(this.reportDateValue[1]);
    } else if (FileTypeValue == ("CAIS").toLocaleUpperCase()) {
      this.reportDateValue[0] = this.userService.CAISLastReportDate;
      this.reportDateValue[1] = this.userService.CAISLastReportDate;
        this.datepickerService.dateRange=[];
      this.datepickerService.dateRange[0] =new Date(this.reportDateValue[0]);
      this.datepickerService.dateRange[1] =new Date(this.reportDateValue[1]);
    }  
    this.validateFileType(FileTypeValue);
    if(FileTypeValue === ("Submit CAT File").toLocaleUpperCase()){
       this.getGroupList();
     }
  }

  validateFileType(file_type: any) {
    this.action = "upload";
    file_type = file_type !== null ? file_type.toLocaleUpperCase() : "";
    let file_subtype: any;
    if (file_type == ("Client Data").toLocaleUpperCase()) {
      this.GridColumns = this.gridColumnsClient;
      this.FileExtentionValue = "";
      this.isDiableFileupload = false;
      this.isDiableFileType = true;
      this.ClientDataFileTypeValue = [];
      this.getFileTypeMessage = 'Select .csv and .psv files only';
    } else if (file_type == ("CAT").toLocaleUpperCase()) {
      this.GridColumns = this.gridColumnsCAT;
      if (this.CATDataFileTypeValue == ("CAT Metadata")) {
        this.FileExtentionValue = ".json,.csv,.bz2";
        this.getFileTypeMessage = 'Select .meta.csv and meta.json files only';
      } else {
        this.FileExtentionValue = ".csv,.json,.bz2";
        this.getFileTypeMessage = 'Select .csv,.json, .json.bz2 files only';
      }
      this.isDiableFileupload = false;
      this.isDiableFileType = true;
      this.ClientDataFileTypeValue = [];
    } else if (file_type === null || file_type === "") {
      this.isDiableFileupload = true;
      this.isDiableFileType = false;
      this.ClientDataFileTypeValue = [];
    } else if (file_type == ("CAIS").toLocaleUpperCase()) {
      this.GridColumns = this.gridColumnsCAIS;
      this.FileExtentionValue = "";
      this.isDiableFileupload = false;
      this.isDiableFileType = true;
      this.ClientDataFileTypeValue = [];
      this.getFileTypeMessage = 'Select .csv and .psv files only';
    } else if (file_type === ("Submit CAT File").toLocaleUpperCase()) {
      this.GridColumns = this.gridColumnsCAT;
      this.FileExtentionValue = ".csv,.json,.bz2";
      this.getFileTypeMessage = 'Select .csv , .json, .csv.bz2 and .json.bz2 files only';
      this.isDiableFileupload = false;
      this.isDiableFileType = true;
      this.ClientDataFileTypeValue = [];
    } else if (file_type === ("FINRA Named Error File").toLocaleUpperCase()) {
      this.GridColumns = this.gridColumnsCAT;
      this.FileExtentionValue = ".bz2";
      this.getFileTypeMessage = 'Select CSV OR JSON .bz2 files only';
      this.isDiableFileupload = false;
      this.isDiableFileType = true;
      this.ClientDataFileTypeValue = [];
    }
    this.FileUploadUrl = this.tempFileUploadUrl + file_type + "/" + this.userService.getActiveMPID() + "/" +this.userService.getyyyyMMddDateFormate(this.reportDateValue[0])+ "/" + this.userService.getUid() + "/" + this.action + "/";
    this.getFileUploadDetails();
    if (this.myfiles)
      this.myfiles.files = [];
  }

  validateFileUpload(event:any, type:any) {
    if (this.ClientDataFileTypeValue.length > 0) {
      this.isDiableFileupload = false;
      this.isUploadEnable = false;
      // added comment to stop client data files validation as per requirement
      // this.validateFileTest(event, this.myfiles);
      // this.isDiableFileupload = false;
    }
    else if (type == "CAT") {
      this.isDiableFileupload = false;
    } else {
      this.isDiableFileupload = false;
    }
  }
  /*   public dropped(event: UploadEvent) {
      this.files = event.files;
  
    }
    public fileOver(event){
    }
   
    public fileLeave(event){
    }
  */
  onUpload(event:any) {
    this.isUploadEnable = false;
    this.totalSizePercent=0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.getFileUploadDetails();
    this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
    this.isStartProcessingDisable = false;
    this.userService.logUserActivity('File Upload', 'File Processing', {
      'Text1': 'File uploaded successfully for the fileType: ' + this.FileTypeValue + ', Total ' + event.files.length + ' Files Uploaded',
      'Text2': 'File List: ' + (event.files.length > 0 ? event.files.map((e:any) => e.name).join() : '')
    });

    /* Process after Upload feature */
      if (this.FileTypeValue.toLocaleUpperCase() !== ("FINRA Named Error File").toLocaleUpperCase()) {
        this.resetParameters();
        this.getGroupList();
      } else if (this.FileTypeValue.toLocaleUpperCase() === ("FINRA Named Error File").toLocaleUpperCase()) {
        this.setStartProcessing();
      }
    /* End of Process after Upload feature */
  }
  onUploadFailed(e:any) {
    this.messageService.add({ severity: 'error', summary: 'File upload failed', detail: '' });
    this.userService.logUserActivity('File Upload', 'File Processing', {
      'Text1': 'File uploading failed for the fileType: ' + this.FileTypeValue + ', Total ' + e.files.length + ' Files Uploaded',
      'Text2': 'File List: ' + (e.files.length > 0 ? e.files.map((e:any) => e.name).join() : '')
    });
  }
  onBeforeSend(event:any) {
    // Set HTTP Header Token for Accessing API
    this.httpHeaders = this.sharedHttpClientService.fileUploadToken();
    this.isUploadEnable = false;
  }

  downloadFile(row:any, i:any) {
    let tempURl:any;
    let folder;
    let fileName: any;
    let groupName;
    let msg: string;
    this.downloadStatus = "Downloading..";
    if (this.FileTypeValue == "" || this.FileTypeValue == null)
      this.FileTypeValue="CAT";//for default

    if(this.FileTypeValue=="CAT"){
      tempURl = this.urlsService.setAPIURl(APIURL.CATFileDownload);
      folder = row['Source'];
      fileName = row['fileName'];
      groupName = row['groupName'];
      msg = ' for the Report Date: ' + row['reportDate'] + ' and File Group: ' + groupName;
    }

    if(this.FileTypeValue == "CAIS") {
      tempURl = this.urlsService.setAPIURl(APIURL.CAISFileDownload);
      folder = row['processedFlag'];
      fileName = row['fileName'];
      msg = ' for the Report Date: ' + row['reportDate'] + ' and File Type: ' + row['fileType'];
    }

    let reportDate: string = (row['reportDate']);
    if (reportDate != "")
      reportDate = this.userService.getyyyyMMddDateFormate(reportDate);

    this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Started ' + fileName });
    this.dataService.getFileDownload(
      tempURl, fileName, folder, reportDate
      )
    .subscribe({
      next: (response:any) => {        
       let dataArray: any[] = [];
       dataArray.push(response);
        const blob = new Blob([dataArray+""], { type: 'application/octet-stream' });
      let filename = fileName;
      if(this.FileTypeValue == "CAIS" && filename.includes(".bz2")) {
        filename = filename.substring(0, filename.length - 4);
      }
      saveAs(blob, filename);
      this.downloadStatus = "";
      this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
      this.userService.logUserActivity('File Download', 'File Processing', {
        'Text1': 'File Downloaded by ' + this.userService.getUserName() + msg,
        'Text2': 'File ' + fileName + ' Download Successully'
      });
      },
      error: (err: HttpErrorResponse) => {
        this.downloadStatus = "";
          this.messageService.add({ severity: 'warn', summary: 'File', detail: 'File Download Failed-' + "'" + 'No such File in the folder please generate file first' + "'" });
          this.userService.logUserActivity('File Download', 'File Processing', {
          'Text1': 'File Downloaded by ' + this.userService.getUserName() + msg,
          'Text2': 'File ' + fileName + ' Download Failed, No such File in the folder please generate file first'
        });
      }
    });
  }

  // **** Code read files and  generate Viewa Queries - NITIN Wahale*/
  validateFileTest1(event:any, uploader: FileUpload) {
    let FilesArray = [];
    for (let i = 0; i < Object.keys(uploader.files).length; i++) {
      let file: File = uploader.files[i];
      FilesArray.push(file);
    }
    this.createTableView(FilesArray);
  }
  findCSVDisplayColumns(uploader: any) {
    for (let i = 0; i < uploader.length; i++) {
      let file: File = uploader[i];
      let cols: any = [];
      let filename = file.name;
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let text: any = reader.result;
        const fileLines: any[] = (text.split("\n"));
        let fileBuffer: any;
        fileBuffer = fileLines[0];
        fileLines.forEach(element => {
          let colvalue: string[] = element.split(',');
          let v: any = "'" + colvalue + "'";
          cols.push(v);
          let flag: any = colvalue[6];
          if (flag) {
            flag.toLocaleUpperCase();
            if (flag.includes('Y') || flag.includes('y')) {
              this.array.push(colvalue[1]);
            }
          }
        });
      }
    }

  }
  // **** Code read for Create Views-NITIN Wahale 
  // ***/
  createTableView(uploader: any) {
    let temp = [];
    let ViewArray = [];
    for (let i = 0; i < uploader.length; i++) {
      let file: File = uploader[i];
      let cols: any = [];
      let filename = file.name;
      let tablename = filename;
      let db_name = 'cat_transaction_db'
      let iend = filename.indexOf(".");

      if (iend != -1) {
        tablename = filename.substring(0, iend); //this will give atable name
      }
      let reader: FileReader = new FileReader();

      reader.readAsText(file);
      reader.onload = (e) => {
        let text: any = reader.result;
        const fileLines: any[] = (text.split("\n"));
        let fileBuffer: any;
        fileBuffer = fileLines[0];
        this.array = [];
        fileLines.forEach(element => {
          let colvalue: string[] = element.split(',');
          let v: any = "'" + colvalue + "'";
          cols.push(v);
          let flag: any = colvalue[5];
        
          this.array.push(colvalue[1]); //Get Field name
          
        });
        temp = [];
        temp = this.array;
        let temp2 = [
          "fileID",
          "reportDate",
          "rsmsStatus",
          "groupName",
          "actionType",
          "errorROEID",
          "firmROEID",
          "type",
          "CATReporterIMID",
          "aggOrderKeyDate",
          "aggOrderID",
          "symbol",
          "orderID",
          "orderKeyDate",
          "quantity",
          "originatingIMID",
          "priorOrderKeyDate",
          "priorOrderID",
          "eventTimestamp",
          "side",
          "price",
          "minQty",
          "leavesQty",
          "orderType",
          "timeInForce",
          "tradingSession",
          "handlingInstructions",
          "seqNum",
          "atsDisplayInd",
          "displayPrice",
          "workingPrice",
          "displayQty",
          "nbbPrice",
          "nbbQty",
          "nboPrice",
          "nboQty",
          "nbboSource",
          "nbboTimestamp",
          "fillKeyDate",
          "fulfillmentID",
          "priorFillKeyDate",
          "priorFulfillmentID",
          "manualFlag",
          "electronicTimestamp",
          "capacity",
          "fulfillmentLinkType",
          "clientDetails",
          "firmDetails",
          "parentOrderKeyDate",
          "parentOrderID",
          "deptType",
          "receivingDeskType",
          "infoBarrierID",
          "electronicDupFlag",
          "manualOrderKeyDate",
          "manualOrderID",
          "reservedForFutureUse1",
          "reservedForFutureUse2",
          "custDspIntrFlag",
          "firmDesignatedID",
          "accountHolderType",
          "affiliateFlag",
          "aggregatedOrders",
          "negotiatedTradeFlag",
          "representativeInd",
          "atsOrderType",
          "quoteKeyDate",
          "quoteID",
          "priorQuoteKeyDate",
          "priorQuoteID",
          "senderIMID",
          "destination",
          "routedQuoteID",
          "onlyOneQuoteFlag",
          "bidPrice",
          "bidQty",
          "askPrice",
          "askQty",
          "unsolicitedInd",
          "mpStatusCode",
          "quoteRejectedFlag",
          "receiverIMID",
          "senderType",
          "routedOrderID",
          "isoInd",
          "cancelQty",
          "initiator",
          "cancelFlag",
          "cancelTimestamp",
          "reservedForFutureUse3",
          "reservedForFutureUse4",
          "destinationType",
          "session",
          "routeRejectedFlag",
          "dupROIDCond",
          "reservedForFutureUse",
          "tradeKeyDate",
          "tradeID",
          "tapeTradeID",
          "marketCenterID",
          "sideDetailsInd",
          "buyDetails",
          "sellDetails",
          "reportingExceptionCode",
          "receivedQuoteID",
          "quoteWantedInd",
          "optionID",
          "openCloseIndicator",
          "priorUnlinked",
          "nextUnlinked",
          "exchOriginCode"
        ];

        let Str: any;
        let FullStr = "CREATE VIEW " + db_name + ".vw_tbl_" + tablename.toLocaleLowerCase() + " AS SELECT ";
        let valid: any = false
        for (let i = 0; i < temp2.length; i++) {
          for (let j = 0; j < temp.length; j++) {
            if (temp2[i] != null && temp2[i] != " " && temp2[i] != "" && temp[j] != null && temp[j] != " " && temp[j] != "") {
              if (temp2[i].toLocaleLowerCase() == temp[j].toLocaleLowerCase()) {
                valid = true
                break;
              }
            }
          }
          if (valid) {
            Str = " t." + temp2[i] + "                     AS " + temp2[i] + ", ";
          }
          else {
            Str = " NULL                         AS " + temp2[i];
            if (i != temp2.length - 1) {
              Str = Str + ",  ";
            } else {
              + "\n";
            }
          }
          FullStr = FullStr + "\n" + Str;
          valid = false
        }
        FullStr = FullStr + " FROM " + db_name + ".tbl_" + tablename.toLocaleLowerCase() + " t ;";
        ViewArray.push(FullStr)
      }
    }
  }




  validateFileTest(event:any, uploader: FileUpload) {
    /*** Validate File  */
    let FileType: string = this.FileTypeValue;
    FileType = FileType.toLocaleUpperCase();
    if (FileType == ("CAT").toLocaleUpperCase() || FileType == ("CAT Metadata").toLocaleUpperCase()) {
      this.CATFileValidation(event, uploader);
    }
    if (FileType == ("Client Data").toLocaleUpperCase()) {
      this.basicFileValidation(event, uploader)
    }
    if (FileType == ("CAIS").toLocaleUpperCase()) {
      this.caisFileValidation(event, uploader)
    }
    if (FileType === ("Submit CAT File").toLocaleUpperCase()) {
      this.SubmitCATFileValidation(event, uploader);
    }
    if (FileType === ("FINRA Named Error File").toLocaleUpperCase()) {
      this.FinraNamedErrorFileValidation(event, uploader);
    }
  }
  basicFileValidation(event:any, uploader:any) {
    let fileNameMust = this.MPID + "_";
    let invalidFiles: any = [];
    let validFiles: any = [];
    for (let i = 0; i < Object.keys(uploader.files).length; i++) { 
      let filename = uploader.files[i].name;
      let file: File = uploader.files[i];
      if (filename.startsWith((fileNameMust)) || filename.startsWith((fileNameMust.toLowerCase()))) {
        validFiles.push(file);
        this.isUploadEnable = false;
      } else {
        this.isUploadEnable = false;
        invalidFiles.push(file);
      }
    }
    for (let i = 0; i < invalidFiles.length; i++) {
      let index = uploader.files.indexOf(invalidFiles[i]);
      uploader.remove(event, index);
      this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i].name });
    }
  }

  ClientFileValidation(event:any, uploader: FileUpload) {
    let FileNameMust: any;
    let invalidFiles = [];
    let validFiles = [];
    if (uploader) {
      for (let i = 0; i < Object.keys(uploader.files).length; i++) {
        let file: any = uploader.files[i];
        let filename = file.name;
        let machingFilename = filename.toLocaleUpperCase();
        let count = 1;
        if ((this.FileTypeValue).toLocaleUpperCase() == ("Client Data").toLocaleUpperCase()) {
          for (let j = 0; j < this.ClientDataFileTypeValue.length; j++) {//client files
            FileNameMust = "";
            if (this.ClientDataFileTypeValue[j] == "Order") {
              FileNameMust = this.MPID + "_ORDER_";
            }
            else if (this.ClientDataFileTypeValue[j] == "Trade") {
              FileNameMust = this.MPID + "_TRADE_SUMMARY_";
            } else if (this.ClientDataFileTypeValue[j] == "Route") {
              FileNameMust = "AUDIT_TRAIL_";
            } else if (this.ClientDataFileTypeValue[j] == "Recon") {
              FileNameMust = this.MPID + "_RECON_";
            } else if (this.ClientDataFileTypeValue[j] == "Trade Report") {
              FileNameMust = this.MPID + "_TRADE_REPORT_";
            }
            let templen = FileNameMust + "YYYYMMDD.psv";
            if (machingFilename.startsWith((FileNameMust))) {
              validFiles.push(file);
              break;
            }
            count++;
            if (count == this.ClientDataFileTypeValue.length) {
              this.isUploadEnable = false;
              let index = uploader.files.indexOf(file);
              invalidFiles.push(file);
            }
          }
        }
      }
    }
    for (let i = 0; i < invalidFiles.length; i++) {
      let index = uploader.files.indexOf(invalidFiles[i]);
      uploader.remove(event, index);
      this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i].name });
    }
    for (let i = 0; i < validFiles.length; i++) {
      let reader = new FileReader();
      reader.readAsText(validFiles[i]);
      reader.onload = (e) => {
        let text: any = reader.result;
        let fileLines = (text.split("\n"));
        let fileBuffer = fileLines[0];
        fileBuffer = (fileBuffer.split(""));
        let pipeDelimeter = "|";
        let commaDelimeter = ","
        if ((fileBuffer.includes(pipeDelimeter) || fileBuffer.includes(commaDelimeter))) {
          this.isUploadEnable = false;
        } else {
          let index = uploader.files.indexOf(validFiles[i]);
          uploader.remove(event, index);
          this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i].name });
        }
      }
    }
  }

  CATFileValidation(event:any, uploader:any) {
    let invalidFiles = [];
    let validFiles = [];
    let activeMPID = this.userService.getActiveMPID();
    if (uploader) {
      let uplodedFiles: Array<any> = uploader.files.slice();
      for (let i = 0; i < uplodedFiles.length; i++) {
        let fileName: any = uplodedFiles[i].name.toLocaleUpperCase();
        if (fileName.split('_').indexOf(activeMPID) === -1) {
          invalidFiles.push(fileName)
        } else {
          validFiles.push(fileName)
        }
      }
      if (invalidFiles.length > 0) {
        invalidFiles.forEach((file, i) => {
          let index = uploader.files.indexOf(invalidFiles[i]);
          uploader.remove(event, index);
          this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i] });
        })
      }
      if (validFiles.length > 0) {
        this.isUploadEnable = false;
      }
    }
  }

  caisFileValidation(event:any, uploader:any) {
    let fileNameMust = this.MPID + "_";
    let invalidFiles: any = [];
    let validFiles: any = [];
    for (let i = 0; i < Object.keys(uploader.files).length; i++) {
      let filename = uploader.files[i].name;
      let fileExtension = uploader.files[i].name.split('.').pop();
      let file: File = uploader.files[i];
      if ((filename.startsWith((fileNameMust)) || filename.startsWith((fileNameMust.toLowerCase()))) && _.includes(['dat', 'psv','DAT','PSV'], fileExtension)) {
        validFiles.push(file);
        this.isUploadEnable = false;
      } else {
        this.isUploadEnable = false;
        invalidFiles.push(file);
      }
    }
    for (let i = 0; i < invalidFiles.length; i++) {
      let index = uploader.files.indexOf(invalidFiles[i]);
      uploader.remove(event, index);
      this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i].name });
    }
  }

  SubmitCATFileValidation(event:any, uploader:any) {
    let fileNameMust = "93006_" + this.MPID + "_";
    let invalidFiles: any = [];
    let validFiles: any = [];
    for (let i = 0; i < Object.keys(uploader.files).length; i++) {
      let filename = uploader.files[i].name;
      let fileExtension = uploader.files[i].name.split('.').pop();
      const fileNameWords = uploader.files[i].name.trim().split('_');
      const fileNameLastWord = fileNameWords[fileNameWords.length - 1];
      let file: File = uploader.files[i];
      if ((filename.startsWith(fileNameMust) || filename.startsWith(fileNameMust.toLowerCase())) && _.includes(['csv', 'json','bz2'], fileExtension) && !fileNameLastWord.startsWith("00000")) {
        validFiles.push(file);
        this.isUploadEnable = false;
      } else {
        this.isUploadEnable = false;
        invalidFiles.push(file);
      }
    }
    for (let i = 0; i < invalidFiles.length; i++) {
      let index = uploader.files.indexOf(invalidFiles[i]);
      uploader.remove(event, index);
      this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file ' + invalidFiles[i].name });
    }
  }

  FinraNamedErrorFileValidation(event:any, uploader:any) {
    let fileNameMust = "linkage";
    let invalidFiles: any = [];
    let validFiles: any = [];
    let mpidList = this.userService.getMPLIDList().map((resultObj: any) => resultObj.mpid).filter((resElement: any) => this.userService.activeMPID !== resElement);
    for (let i = 0; i < Object.keys(uploader.files).length; i++) {
      let filename = uploader.files[i].name;
      let fileExtension = uploader.files[i].name.split('.').pop();
      let fileNameDetail = uploader.files[i].name.trim().split('_');
      let file: File = uploader.files[i];
      if (filename.startsWith(this.userService.CRDID) 
          && (filename.split('_').indexOf(this.userService.activeMPID) !== -1 || !_.includes(mpidList, fileNameDetail[1])) 
          && (filename.includes((fileNameMust.toLowerCase())) 
          && (filename.toLowerCase().includes(".json") || filename.toLowerCase().includes(".csv")) 
          && _.includes(['bz2'], fileExtension.toLowerCase()))) {
        validFiles.push(file);
        this.isUploadEnable = false;
      } else {
        this.isUploadEnable = false;
        invalidFiles.push(file);
      }
    }
    for (let i = 0; i < invalidFiles.length; i++) {
      let index = uploader.files.indexOf(invalidFiles[i]);
      uploader.remove(event, index);
      this.messageService.add({ severity: 'error', summary: this.FileTypeValue, detail: 'Please select correct format of file  ' + invalidFiles[i].name });
    }
  }

  getSizeInMegaBytes(file: File) {
    return file ? file.size / 1000000 : 0;
  }

  removeFile(file: File, uploade:any, i:any) {
    uploade.remove(file, i);
    this.isUploadEnable = false;
    this.userService.logUserActivity('File Removed from Upload List', 'File Processing', {
      'Text1': 'File ' + file.name + ' has been removed from Upload List by ' + this.userService.getUserName(),
      'Text2': ''
    });

  }

  getFileUploadDetails() {
    const defaultFilterArray = [
      { 'isdefault': 'true', 'label': 'reportDate', 'columnname': 'reportDate', 'filterby': '', 'values': [this.userService.getyyyyMMddDateFormate(this.reportDateValue[0]), this.reportDateValue[1] ? this.userService.getyyyyMMddDateFormate(this.reportDateValue[1]): this.userService.getyyyyMMddDateFormate(this.reportDateValue[0])], 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'groupName', 'columnname': 'groupName', 'filterby': 'IS', 'values': this.groupValue ? this.groupValue.toString() : '', 'time': '', 'datatype': 'string', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'submitter', 'columnname': 'submitter', 'filterby': 'IS', 'values': this.submitterValue ? this.submitterValue.toString() : '', 'time': '', 'datatype': 'string', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
    ];
    this.selectedRowLength = 0;
    this.isLoadingResults = true;
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FileUploadDetails), {
        "action": this.action,
        "mpid": this.userService.getActiveMPID(),
        "reportDate": this.userService.getyyyyMMddDateFormate(this.reportDateValue[0]),
        "uid": this.userService.getUid(),
        "filetype": this.FileTypeValue !== null ? this.FileTypeValue : "",
        "data": defaultFilterArray
      })   
      .subscribe({
        next: (result:any) => {
        this.dataset = [];
        this.groupList = [];
        this.submitterList = [];
        let data = result;
        if (data !== undefined && data) {
          this.dataset = data.Data !== undefined ? data.Data : [];
          if (data.GroupList && data.GroupList.length > 0) {
            data.GroupList.forEach((element:any) => {
              this.groupList.push({ label: element.groupName, value: element.groupName })
            });
          }
          if (data.SubmitterList && data.SubmitterList.length > 0) {
            data.SubmitterList.forEach((element:any) => {
              if (element.submitter === 0) {
                element.submitter = '0';
              }
              this.submitterList.push({ label: element.submitter, value: element.submitter })
            });
          }
          this.isLoadingResults = false;
        }
        },
        error: (error:any) => {
          this.isLoadingResults = false;
        }
      });  
  }


  setClearData(rowData:any) {
    let msg = '';
    if (this.selectedRow.length > 1)
      msg = 'Are you sure you want to delete selected files?';
    else
      msg = 'Are you sure you want to delete selected file?';
    this.confirmationService.confirm({
      message: msg,
      accept: () => {
        let Data = {
          'P_selectedRows': this.selectedRow,
          "P_Updated_By": this.userService.getUserName()
        };
        this.selectedRowLength = Object.keys(this.selectedRow).length;
        if (this.selectedRowLength != 0) {
          this.clearData = true;
          for (let i = 0; i < this.selectedRowLength; i++) {
            this.deleteFile('multiDelete', i);
          }
        } else {
          this.selectedRow = rowData;
          this.deleteFile('singleDelete', null);
        }
      }
    });


  }

  deleteFile(action?: string, index?: any) {
    let filename = action === 'singleDelete' ? this.selectedRow.fileName : this.selectedRow[index].fileName;
    let date = action === 'singleDelete' ? this.selectedRow.reportDate : this.selectedRow[index].reportDate;
    let tempURl = this.urlsService.setAPIURl(
      APIURL.FileUploadDelete) + filename + "/" + this.userService.getActiveMPID() + "/" + this.userService.getUid() + "/" + date;
    this.sharedHttpClientService.post(tempURl, {})
      .pipe(map((response:any) => {
        return response;
      }))
      .subscribe({
        next: (result: any) => {
          this.clearData = false;
            if (result[0].sucess == "true") {
              this.messageService.add({ severity: 'success', summary: 'Files Deleted', detail: 'File ' + filename + ' Deleted' });
              this.getFileUploadDetails();
            }
            else {
              this.messageService.add({ severity: 'error', summary: 'Files', detail: 'Failed !' });
            }
            this.userService.logUserActivity('File Removing from Data Grid', 'File Processing', {
              'Text1': 'File Removed by ' + this.userService.getUserName() + ' for the Report Date: ' + date + ' and File Group: ' + (action === 'singleDelete' ? this.selectedRow.groupName : this.selectedRow[index].groupName),
              'Text2': (result[0].sucess == "true" ? 'File ' + filename + ' Deleted' : 'File ' + filename + ' Deletion Failed')
            });
            if(action === 'singleDelete' || (this.selectedRow.length - 1) === index) {
              this.selectedRow = [];
            }
        },
        error: (error:any) => {
          this.userService.logUserActivity('File Removing from Data Grid', 'File Processing', {
            'Text1': 'File Removed by ' + this.userService.getUserName() + ' for the Report Date: ' + date + ' and File Group: ' + (action === 'singleDelete' ? this.selectedRow.groupName : this.selectedRow[index].groupName),
            'Text2': 'File ' + filename + ' Deletion Failed'
          });
          this.selectedRow = [];
          this.clearData = false;
          this.messageService.add({ severity: 'error', summary: 'Files', detail: 'Failed !' });
        }
      });
  }
  runScript() {
    this.userService.logUserActivity('File Process Validation', 'File Processing', {
      'Text1': 'File processing started by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.selectedGroup,
      'Text2': 'File Processing Started'
    });
    let tempURl = this.urlsService.setAPIURl(
      APIURL.RunScript);
    this.sharedHttpClientService.post(tempURl, {
      scriptType: this.FileTypeValue +' Validation',
      fileProcessType: 'Validation',
      mpid: this.userService.getActiveMPID(),
      groupName: this.selectedGroup,
      reportDate: this.userService.getyyyyMMddDateFormate(this.selectedReportDate).replace(/[_-]/g, ""),
      submitterID: 0,
      reporterID: this.userService.getActiveMPID(),
      user: this.userService.userFirstName,
      genClientData: this.FileTypeValue === 'Client Data' ? 'Y' : 'N',
      uploadedFileList: (this.uploadedFiles.length > 0 ? this.uploadedFiles.map((e:any) => e.name) : [])
    })
    .subscribe({
        next: (response: any) => {
          let result = response;
        // this.isStartProcessingDisable = false;
        if (result.isScripttypeFailed == "true") {
          this.messageService.add({ severity: 'error', summary: result.Scripttype, detail: "File Processing Failed" });
          this.userService.logUserActivity('File Process Validation', 'File Processing', {
            'Text1': 'File processed by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.selectedGroup,
            'Text2': 'File Processing Failed'
          });
        } else {
          this.messageService.add({ severity: 'success', summary: result.Scripttype, detail: "File Processing Completed" });
          this.userService.logUserActivity('File Process Validation', 'File Processing', {
            'Text1': 'File processed by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.selectedGroup,
            'Text2': 'File Processing Completed'
          });
        }
        this.getFileUploadDetails();
        },
        error: (err: HttpErrorResponse) => {
          // this.isStartProcessingDisable = false;
          this.getFileUploadDetails();
        }
      });  
  }

  CallFileSubmissionScript() {
    this.userService.logUserActivity('File Submission Process', 'File Processing', {
      'Text1': 'File submission started by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.userService.getActiveMPID(),
      'Text2': 'File submission started'
    });

    let payload = {
      scriptType: 'Finra Submit',
      fileProcessType: 'Submit',
      mpid: this.userService.getActiveMPID(),
      groupName: this.userService.getActiveMPID(),
      reportDate: this.userService.getyyyyMMddDateFormate(this.selectedReportDate),
      reporterID: this.userService.getActiveMPID(),
      user: this.userService.userFirstName
    };

    this.sharedHttpClientService.post(this.urlsService.setAPIURl(
        APIURL.RunScript
      ), payload
    )
    .subscribe({
      next: (response: any) => {
        let result = response;
          if (result.isScripttypeFailed == "true") {
            this.messageService.add({ severity: 'error', summary: result.Scripttype, detail: "File Processing Failed" });
            this.userService.logUserActivity('File Submission Process', 'File Processing', {
              'Text1': 'File submitted by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.userService.getActiveMPID(),
              'Text2': 'File submission failed'
            });
          } else {
            this.messageService.add({ severity: 'success', summary: result.Scripttype, detail: "File Processing Completed" });
            this.userService.logUserActivity('File Submission Process', 'File Processing', {
              'Text1': 'File submitted by ' + this.userService.getUserName() + ' for the Upload fileType: ' + this.FileTypeValue + ', Reporter: ' + this.userService.getActiveMPID() + ', Report Date: ' + this.userService.getyyyyMMddDateFormate(this.selectedReportDate) + ' and File Group: ' + this.userService.getActiveMPID(),
              'Text2': 'File submission completed'
            });
          }
          this.getFileUploadDetails();
      },
      error: (err: HttpErrorResponse) => {
        this.getFileUploadDetails();
      }
    });
  }

  triggerFileUpload() {
    if(this.FileTypeValue && this.FileTypeValue!=""){
      let files:any = [];
      files = this.myfiles["_files"]
      this.totalSizePercent=100;
      if (files && files.length>0) {
        this.myfiles.upload(); // This will trigger the p-fileUpload's upload feture in custom way
      }else{
        this.isSelectProcessDate=true;
        if(this.selectedReportDate){
        this.getGroupList(); 
        if(this.selectedGroup){
          this.isDisableSubmit=false;
        }
      }
      }
    }
      else{
          this.messageService.add({ severity: 'info', summary: 'Files Upload', detail: 'Please select "Upload Type"' });
      }
  }

  resetParameters(){
    this.isSelectProcessDate = true;
    this.isDisableSubmit = true;
    this.selectedGroup=null;
  }

  setStartProcessing() {
    this.isSelectProcessDate = false;
      this.action = "move";
      this.isStartProcessingDisable = true;
      this.startProcessing = true;
      this.dataService.setStartValidationProcess(this.FileTypeValue,this.userService.getyyyyMMddDateFormate(this.reportDateValue[0]))
      .subscribe({
          next: (result: any) => {
            this.startProcessing = false;
            this.messageService.add({ severity: 'success', summary: 'Files Move', detail: 'Files validation Started.' });
            this.isStartProcessingDisable = true;
            this.getFileUploadDetails();
            // Submit Manual Repair CAT File
            if(this.FileTypeValue === "Submit CAT File") {
                this.CallFileSubmissionScript();
            } else {
              this.runScript();
            }
          },  
          error: (error:any) => {
            console.error(error);
            this.startProcessing = false;
          }
        });  
  }

  getGroupList() {
    if(!_.includes(['CAIS', 'FINRA Named Error File'], this.FileTypeValue)) {
      this.isLoadingGroupList = true;
      this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Get_Group_List),
      {
        validationType: this.FileTypeValue,
        mpid: this.userService.getActiveMPID(),
        reportDate:this.userService.getyyyyMMddDateFormate(this.selectedReportDate)
      })     
      .subscribe({
        next: (response:any) => {
          let result = response;
            this.groupListDropDown = [];
            let DataSet: any[] = result.Data;
            this.groupName= DataSet[0].GroupName;
            for (let i = 0; i < DataSet.length; i++) {
              this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName });
            }    
            this.isLoadingGroupList = false;
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: "Loading group list", detail: "Data not found for that report date." });
          this.isLoadingGroupList = false;
        }
      });
    }
  }
  getDateEmitter(isDateRange:any){
    if(isDateRange){
    this.reportDateValue = this.datepickerService.dateRange;
    this.validateFileType(this.FileTypeValue);
    }
    else{
    this.selectedReportDate = this.datepickerService.reportDate;
    this.getGroupList();
    }
  }

}
